import { ChangeDetectionStrategy, Component, OnInit, Signal, WritableSignal, computed, signal } from '@angular/core';
import { UserApi } from 'api/user/user-api.js';
import { FormSaveHandler } from 'lib/ui/form/form-save-button.component.js';
import { map } from 'rxjs';
import { CoreAppComponent } from 'src/app/core/core-app.component.js';
import { loginEmailStoreKey } from './helpers/auth-page-setup.js';
import { EmptyApiObject } from 'api/api-models.js';

@Component({
    templateUrl: './forgotten-password.component.html',
    selector: 'mod-forgotten-password',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ForgottenPasswordComponent extends CoreAppComponent implements OnInit {
	public readonly formSubmitted: WritableSignal<boolean> = signal<boolean>(false);

	public readonly form = {
		email: signal<string | undefined>(undefined),
		password: signal<string | undefined>(undefined)
	};

	public readonly saveHandler = computed<FormSaveHandler>(() => {
		const email = this.form.email();

		if (!email) {
			return undefined;
		}

		const formData: UserApi.ISendForgottenPasswordRequest = {
			email: email
		};

		return this.dependencies.httpService
			.post<EmptyApiObject, UserApi.ISendForgottenPasswordRequest>((builder) =>
				builder.withCustomApiRoute('user', 'sendForgottenPassword').withData(formData).build()
			)
			.pipe(
				map((response) => {
					this.formSubmitted.set(true);
				})
			);
	});

	constructor() {
		super();
	}

	ngOnInit(): void {
		this.form.email.set(this.dependencies.storageService.getValue(loginEmailStoreKey));
	}
}
